export const INITIAL_COLLAPSE = false;
